const o = {
  defaultProps: {
    sx: { paddingX: 2 }
  }
};
export {
  o as dialogContent
};
//# sourceMappingURL=dialogContent2.mjs.map
